(function(global){
  'use strict';
  function calculate(option, products, quantity = 1) {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Invalid quantity');
    const get = handle => {
      const product = products.find(item => item.handle === handle);
      if (!product || !Number.isSafeInteger(product.price) || product.price < 0) throw new Error('Invalid product');
      return product;
    };
    const items = option.items.map(item => {
      if (!Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Invalid component quantity');
      return {...item, product: get(item.handle)};
    });
    const original = items.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
    const discounted = items[option.discountIndex ?? 0];
    let discount = 0;
    if (option.type === 'amount') {
      if (!Number.isSafeInteger(option.amount) || option.amount < 0) throw new Error('Invalid amount');
      discount = Math.min(discounted.product.price, option.amount);
    } else if (option.type === 'percent') {
      if (!Number.isInteger(option.percent) || option.percent < 0 || option.percent > 100) throw new Error('Invalid percentage');
      discount = discounted.product.price - Math.round(discounted.product.price * (100 - option.percent) / 100);
    } else if (option.type === 'match') {
      const source = get(option.priceSource);
      if (source.validBase === false) throw new Error('Invalid price reference');
      discount = original - source.price;
    } else if (option.type !== 'upgrade' && option.type !== 'single') throw new Error('Invalid offer');
    const retail = option.references?.length ? option.references.reduce((sum, handle) => sum + get(handle).price, 0) : original;
    const unitPrice = original - discount;
    return {items, unitPrice, price: unitPrice * quantity, retail: retail * quantity, savings: Math.max(0, retail - unitPrice) * quantity, addonPrice: discounted.product.price - discount, available: items.every(item => item.product.available && item.product.validBase !== false)};
  }
  function cartItems(option, products, quantity, offerId, baseProperties = {}) {
    const calc = calculate(option, products, quantity);
    if (!calc.available) throw new Error('Offer unavailable');
    if (calc.items.some(item=>!Number.isSafeInteger(item.product.variantId)||item.product.variantId<1)) throw new Error('Invalid variant');
    const slots = calc.items.flatMap(item => Array.from({length:item.quantity},()=>item));
    const variants = slots.map(item=>item.product.variantId).join(',');
    return slots.map((item,slot)=>({id:item.product.variantId,quantity,properties:{...(slot===0?baseProperties:{}),_pdp_kit_offer:offerId,_pdp_kit_title:option.title,_pdp_kit_variants:variants,_pdp_kit_schema:'slots-v1',_pdp_kit_slot:String(slot),_pdp_kit_label:item.quantity>1?item.product.title:item.labels.join(' + '),...(item.componentHandles?.length?{_pdp_kit_component_handles:item.componentHandles.join('|')}:{}),...(slot===0&&option.references?.length?{_pdp_kit_reference_handles:option.references.join('|')}:{})}}));
  }
  // Production discounted choices require a recorded server rule. Price-reference matches stay in review.
  function purchasable(option, {production = false, qaCode} = {}) {
    if (option.type === 'single' || option.type === 'upgrade') return true;
    if (production) return ['amount', 'percent'].includes(option.type) && /^\d+$/.test(String(option.discountId || ''));
    return /^QA-PDP-[A-Z0-9-]+$/.test(qaCode || '');
  }
  const pricing = {calculate, cartItems, purchasable};
  if (typeof module !== 'undefined' && module.exports) module.exports = pricing;
  else global.PdpKitPricing = pricing;
})(typeof window !== 'undefined' ? window : globalThis);
